var React = require('react');

function IcPresentation (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;}.cls-2{fill:#fff100;}.cls-3{fill:#008aae;}")),React.createElement("rect",{"id":"Rectangle_480","data-name":"Rectangle 480","className":"cls-1","width":"72","height":"44","key":1}),React.createElement("path",{"className":"cls-3","d":"M36,10A13,13,0,1,1,23,23,13,13,0,0,1,36,10Z","key":2}),React.createElement("path",{"className":"cls-2","d":"M64,1H8A4,4,0,0,0,4,5V39a4,4,0,0,0,4,4H64a4,4,0,0,0,4-4V5A4,4,0,0,0,64,1Zm2,38a2,2,0,0,1-2,2H8a2,2,0,0,1-2-2V5A2,2,0,0,1,8,3H64a2,2,0,0,1,2,2ZM43.85,23.5a1,1,0,0,1-.37.37l-11,6.27a1,1,0,0,1-1.37-.36,1.09,1.09,0,0,1-.13-.5V16.72a1,1,0,0,1,1-1,1.09,1.09,0,0,1,.5.13l11,6.28A1,1,0,0,1,43.85,23.5Z","key":3})]);
}

IcPresentation.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 72 44"};

module.exports = IcPresentation;

IcPresentation.default = IcPresentation;
